<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <aside class="overlay"
      @click="
          $store.state.overlayPicture = {
            index: 0,
            images: [],
            projectTitle: '',
          }
      "
    >
      <button
        type="button"
        class="close-btn"
        @click="
          $store.state.overlayPicture = {
            index: 0,
            images: [],
            projectTitle: '',
          }
        "
      >
        &times;
      </button>
      <div class="overlay-content">
        <picture
          class="scf-picture parallax-picture--"
          data-depth="1"
        >
          <img
            :src="`./images/projects/${$store.state.overlayPicture.images[$store.state.overlayPicture.index]}`"
            :alt="`${$store.state.overlayPicture.projectTitle} | image #${$store.state.overlayPicture.index + 1}`"
          />
        </picture>
        <div class="overlay-navigation">
          <button
            type="button"
            aria-label="next image"
            class="next-btn"
            :disabled="$store.state.overlayPicture.index + 1 >= $store.state.overlayPicture.images.length"
            @click.stop="
              $store.state.overlayPicture = {
                index: $store.state.overlayPicture.index + 1,
                images: $store.state.overlayPicture.images,
                projectTitle: $store.state.overlayPicture.projectTitle,
              }
            "
          >
          </button>
          <button
            type="button"
            aria-label="previous image"
            class="prev-btn"
            :disabled="$store.state.overlayPicture.index < 1"
            @click.stop="
              $store.state.overlayPicture = {
                index: $store.state.overlayPicture.index - 1,
                images: $store.state.overlayPicture.images,
                projectTitle: $store.state.overlayPicture.projectTitle,
              }
            "
          >
          </button>
        </div>
      </div>
      <div class="overlay-pagination">
        {{ $store.state.overlayPicture.index + 1 }} / {{ $store.state.overlayPicture.images.length }}
      </div>
    </aside>
  </Transition>
</template>

<script>
export default {
  name: "OverlayPicture",
};
</script>

<style lang="less" scoped>
@import "../styles/all.less";

/* The Overlay */
.overlay {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: @max-z-index-page;
  left: 0;
  top: 0;
  background-color: @black-80;
  overflow-x: hidden;
  transition: 0.5s;
}

.overlay-content {
  position: relative;

  .scf-picture {
    display: block;

    img {
      max-width: 100vw;
      max-height: 100vh;
      object-fit: contain;
    }
  }
}
.overlay-navigation {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  align-content: stretch;

  .next-btn,
  .prev-btn {
    flex: 1;
    cursor: pointer;
    background-color: transparent;
    border: none;

    &[disabled] {
      cursor: auto;
    }
  }
}

.overlay-pagination {
  position: absolute;
  bottom: @scf-space-xs;
  right: @scf-space-xs;
  z-index: @max-z-index-page + 1;
  color: @white;
  background-color: @black-60;
  padding: @scf-space-s @scf-space-sm;
  margin: 0;
  border-radius: @scf-space-xs;
}

.overlay {
  .close-btn {
    position: fixed;
    z-index: @max-z-index-page + 1;
    cursor: pointer;
    top: @scf-space-sm;
    right: @scf-space-sm;
    text-decoration: none;
    font-size: @scf-space-l;
    line-height: @scf-space-l;
    width: @scf-space-l;
    height: @scf-space-l;
    color: @white-60;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    background-color: @black-40;
    border-radius: 50%;

    &:hover,
    &:focus {
      color: @white;
      background-color: @black-60;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
